/**
 * Firestore: merchants/{merchantId}/posts/{postId}
 * Fields: merchantId, merchantName, text, photoUrl, createdAt (camelCase).
 * Cross-merchant reads use collectionGroup("posts") in PostsFeed.
 */
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { firebaseDb } from "../firebase/firebaseClient";

export async function createMerchantPost(merchantId, merchantName, { text, photoUrl }) {
  const mid = String(merchantId || "").trim();
  const name = String(merchantName || "").trim();
  const body = String(text || "").trim();
  if (!mid) throw new Error("createMerchantPost: merchantId is required");
  if (!body) throw new Error("createMerchantPost: text is required");

  const payload = {
    merchantId: mid,
    merchantName: name,
    text: body,
    photoUrl: photoUrl || null,
    createdAt: serverTimestamp(),
  };

  await addDoc(collection(firebaseDb, "merchants", mid, "posts"), payload);
}
